import { arrayOf, enumOf, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isConversationalPreviewMessageHistoryResult = objectOf({
  results: arrayOf(
    objectOf({
      id: string,
      direction: enumOf("inbound", "outbound"),
      content: string,
      timestamp: number,
    })
  ),
  limit: number,
});
